import { colors } from '@dixa/lib-shared-tokens';
export const conversationStatusAttributes = new Map([
    ['open', { prettyName: 'Open', color: colors.green['500'] }],
    ['closed', { prettyName: 'Closed', color: colors.neutral['500'] }],
    ['pending', { prettyName: 'Follow up', color: colors.blue['500'] }],
    ['awaitingpending', { prettyName: 'Follow up', color: colors.blue['500'] }],
]);
